export default __webpack_public_path__ + "static/media/Tracking_R.ad7d71aa.svg";